import Konva from 'konva';
import * as state from '../state.js';
import { attachInteractive, pointerPos } from './_helpers.js';

let counter = 1;

export function resetNumberCounter() {
  counter = 1;
}

export const number = {
  id: 'number',
  defaultProps: {},
  onPointerDown(engine) {
    const pos = pointerPos(engine);
    if (!engine.pointerInsideImage(pos)) return;
    const color = state.get('selectedColor');
    const group = new Konva.Group({ x: pos.x, y: pos.y });
    const radius = 18;
    const circle = new Konva.Circle({ radius, fill: color });
    const text = new Konva.Text({
      text: String(counter++),
      fontFamily: 'DM Sans, sans-serif',
      fontStyle: '700',
      fontSize: 18,
      fill: '#FFFFFF',
      align: 'center',
      verticalAlign: 'middle',
      width: radius * 2,
      height: radius * 2,
      offsetX: radius,
      offsetY: radius,
    });
    group.add(circle, text);
    attachInteractive(engine, group);
  },
  onPointerMove() {},
  onPointerUp() {},
  apply(node, prop, value) {
    if (prop === 'color') {
      const circle = node.findOne?.('Circle');
      if (circle) circle.fill(value);
    }
  },
};
